import { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchUserActivity } from '~/data/userActivity/slice';
import { UserActivityEventsGetParams } from '~/data/userActivity/types';
import { StoreState } from '~/reducer';
import { userActivityStateSelector } from '~/selectors';
import { Types } from '~/services/Http/client.iam.generated';
import { AppDispatch } from '~/store';

export const useUserActivity = () => {
  const dispatch: AppDispatch = useDispatch();
  const storeState = useSelector((state: StoreState) => {
    return userActivityStateSelector(state);
  });

  const defaultRequestProps = useMemo(
    () => ({
      types: [Types.Read],
    }),
    [],
  );

  const getUserActivity = useCallback(
    (params?: UserActivityEventsGetParams) => {
      const fetchParams: UserActivityEventsGetParams = {
        ...defaultRequestProps,
        ...params,
      };

      return new Promise((resolve, reject) => {
        dispatch(fetchUserActivity(fetchParams))
          .then((resp) => {
            resolve(resp);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    [dispatch, defaultRequestProps],
  );

  return {
    ...storeState,
    getUserActivity,
  };
};
